import { PaymentCount } from './../model/payment_summary';

export const mockPaymentCount: PaymentCount = {
  paymentCount: 1
}
